"use client";

import * as RadixTooltip from "@radix-ui/react-tooltip";
import { Fragment, isValidElement } from "react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { DESKTOP_Z_INDEX } from "../desktopUI.constants";
import { ANCHORED_CONTENT_PROPS } from "./overlay.constants";
import { OVERLAY_MOTION } from "./overlayMotion.constants";
export function Tooltip({
  content,
  children,
  side = "top",
  delayMs = 400,
  className,
  tipClassName,
  shouldPassEscapeThrough = false
}: {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "bottom";
  delayMs?: number;
  className?: string;
  tipClassName?: string;
  shouldPassEscapeThrough?: boolean;
}) {
  const isDisabledControl = isValidElement<{
    disabled?: boolean;
  }>(children) && children.props.disabled === true;
  const isSingleElement = isValidElement(children) && children.type !== Fragment && !isDisabledControl;
  return <RadixTooltip.Provider delayDuration={delayMs} disableHoverableContent data-sentry-element="RadixTooltip.Provider" data-sentry-component="Tooltip" data-sentry-source-file="Tooltip.tsx">
            <RadixTooltip.Root data-sentry-element="RadixTooltip.Root" data-sentry-source-file="Tooltip.tsx">
                <span className={cn("relative inline-flex", className)}>
                    <RadixTooltip.Trigger asChild data-sentry-element="RadixTooltip.Trigger" data-sentry-source-file="Tooltip.tsx">
                        {isSingleElement ? children : <span className="inline-flex">{children}</span>}
                    </RadixTooltip.Trigger>
                </span>
                <RadixTooltip.Portal data-sentry-element="RadixTooltip.Portal" data-sentry-source-file="Tooltip.tsx">
                    <RadixTooltip.Content side={side} {...ANCHORED_CONTENT_PROPS} sideOffset={6} onEscapeKeyDown={event => {
          if (!shouldPassEscapeThrough) return;
          window.dispatchEvent(new KeyboardEvent("keydown", {
            key: event.key,
            bubbles: true,
            // boolean-naming-exempt: external contract — KeyboardEventInit option
            cancelable: true // boolean-naming-exempt: external contract — KeyboardEventInit option
          }));
        }} style={{
          zIndex: DESKTOP_Z_INDEX.TOOLTIP
        }} className={cn("pointer-events-none whitespace-nowrap rounded-field bg-ink px-2.5 py-1 text-caption font-medium text-surface shadow-float", OVERLAY_MOTION.tooltip, tipClassName)} data-sentry-element="RadixTooltip.Content" data-sentry-source-file="Tooltip.tsx">
                        {content}
                    </RadixTooltip.Content>
                </RadixTooltip.Portal>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>;
}